import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchFeatureFlagSettings } from "../../../actions/callrecorder/featureFlagSettingsActions";
import callrecorderUrls from "../../../configs/callrecorder/callrecorderUrls";

import PageLayout from '../_partials/PageLayout';
import Edit from "./Edit";
import ListTable from "./_partials/_ListTable";
import PageHeader from "../../../componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";

const LIMIT = 100;

const FeatureFlags = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;
  const { pathname } = useLocation();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      []
    );

    dispatch(fetchFeatureFlagSettings(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  return (
    <PageLayout className='v-feature-flags'>
      <PageHeader
        title='Feature Flags'
        parent={{
          name: 'Bundles',
          url: callrecorderUrls.bundlesPath()
        }}
      />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <p style={{ margin: 0, color: '#666' }}>
            Flags are defined in code (<code>FeatureFlag::DEFAULTS</code>) and seeded automatically.
            Edit the description or the global default here; toggle per-bundle overrides from each
            Bundle's <em>Feature Flags</em> tab.
          </p>
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>

      <Edit />
    </PageLayout>
  );
}

export default FeatureFlags;
